import { Cog6ToothIcon, Flex, FlexProps, IconButton, Panel, Tooltip } from 'components'
import { usePermission } from 'utils'
import { useEventInfo } from '../../../pages/EventInfoPage'
import MomentsButton from '../MomentsButton'

export default function EventBannerActionButtons(props: FlexProps) {
  const { updateShowManage } = useEventInfo()
  const permission = usePermission()
  const isViewer = permission.event === 'viewer'

  return (
    <Flex gap={2} height="44px" {...props}>
      {!isViewer && (
        <Panel>
          <Tooltip content="Manage">
            <IconButton
              variant="ghost"
              px={3}
              height="100%"
              aria-label="Manage event"
              icon={<Cog6ToothIcon />}
              onClick={() => updateShowManage(true)}
            />
          </Tooltip>
        </Panel>
      )}

      <MomentsButton />
    </Flex>
  )
}
